<template>
  <div class="subject-data">
    <schoolCommonImage />
    <header class="header">
      <h2>教学计划</h2>
    </header>
    <section class="section">
      <div class="subjectList">
        <div class="title">
          <p class="name">科目：scratch</p>
          <el-button type="primary" size="small">马上下载</el-button>
        </div>
        <p class="subjectName">L2 编程与创意</p>
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column type="index" width="50"> </el-table-column>
          <el-table-column label="讲次" prop="name"></el-table-column>
          <el-table-column prop="name" label="讲次名"></el-table-column>
          <el-table-column prop="name" label="课程内容"></el-table-column>
          <el-table-column prop="name" label="知识点"></el-table-column>
        </el-table>
      </div>
      <div class="otherData">
        <el-card class="box-card">
          <h1>其他课程资料</h1>
          <div v-for="o in 4" :key="o" class="download">
            <p>{{ o }}</p>
            <i class="el-icon-download"></i>
          </div>
        </el-card>
      </div>
    </section>
  </div>
</template>

<script>
import schoolCommonImage from "@/components/schoolCommonImage";
export default {
  name: "subject-data",
  components: {
    schoolCommonImage,
  },
  data() {
    return {
      tableData: [
        {
          name: "测试",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.subject-data {
  min-width: 1000px;
  max-width: 1100px;
  margin: 0 auto;
  overflow: hidden;
  .header {
    h2 {
      font-size: 16px;
    }
    padding: 20px 0;
    width: 70%;
    border-bottom: 1px solid #eee;
  }
  .section {
    display: flex;
    .subjectList {
      margin-top: 30px;
      width: 70%;
      padding-right: 40px;
      .title {
        display: flex;
        justify-content: space-between;
        .name {
          font-size: 14px;
        }
      }
      .subjectName {
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        margin: 10px 0;
      }
    }
    .otherData {
      flex: 1;
      h1 {
        font-size: 16px;
        margin-bottom: 15px;
      }
      .download {
        font-size: 16px;
        line-height: 30px;
        display: flex;
        justify-content: space-between;
        .el-icon-download {
          cursor: pointer;
        }
      }
    }
  }
}
</style>


